/* Toy in Trend CRO helpers: delivery dates, gift options, cart drawer gift wrap and add-ons, add buttons,
   sticky buy bar, variant price refresh and review widget layout. */
(() => {
  if (window.CRO_INIT) return;
  window.CRO_INIT = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* ------------------------------------------------------------ delivery dates */
  function dateRange(min, max) {
    const a = new Date();
    a.setDate(a.getDate() + min);
    const b = new Date();
    b.setDate(b.getDate() + max);
    const left = DAYS[a.getDay()] + ' ' + a.getDate() + (a.getMonth() !== b.getMonth() ? ' ' + MONTHS[a.getMonth()] : '');
    return left + ' – ' + DAYS[b.getDay()] + ' ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  }

  function fillEta(scope) {
    (scope || document).querySelectorAll('[data-cro-eta]').forEach((el) => {
      const min = parseInt(el.dataset.min, 10) || 3;
      const max = parseInt(el.dataset.max, 10) || 7;
      const text = dateRange(min, max);
      if (el.textContent !== text) el.textContent = text;
    });
  }

  /* ------------------------------------------------------------ cart requests */
  const drawer = () => document.querySelector('cart-drawer');
  const onCartPage = () => !!document.getElementById('main-cart-items');

  async function cartRequest(path, payload, withSections = true) {
    const d = drawer();
    if (withSections && d && typeof d.getSectionsToRender === 'function' && !onCartPage()) {
      payload.sections = d.getSectionsToRender().map((s) => s.id);
      payload.sections_url = window.location.pathname;
    }
    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    let data = {};
    try {
      data = await res.json();
    } catch (e) {
      /* not JSON */
    }
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    }
    return data;
  }

  async function cartCount() {
    try {
      const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      const data = await res.json();
      return data.item_count || 0;
    } catch (e) {
      return -1;
    }
  }

  function showCart(data) {
    const d = drawer();
    if (
      onCartPage() ||
      !d ||
      typeof d.renderContents !== 'function' ||
      !data.sections ||
      !data.sections['cart-drawer']
    ) {
      window.location.href = root + 'cart';
      return;
    }
    if (typeof data.item_count === 'number') d.classList.toggle('is-empty', data.item_count === 0);
    else d.classList.remove('is-empty');
    d.renderContents(data);
  }

  function busy(el, on) {
    if (!el) return;
    if (on) el.setAttribute('aria-busy', 'true');
    else el.removeAttribute('aria-busy');
  }

  function flashError(el, msg) {
    const host =
      el.closest(
        '.cro-gift, .cro-upsell__card, .cro-card, .cro-combo, .cro-gl__row, .cro-fbt__foot, .cro-sticky__inner, .product-form__buttons'
      ) || el.parentElement;
    if (!host) return;
    let box = host.querySelector('.cro-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'cro-error';
      box.setAttribute('role', 'alert');
      host.appendChild(box);
    }
    box.textContent = msg;
    setTimeout(() => box.remove(), 5000);
  }

  function refocus(selector) {
    if (!selector) return;
    setTimeout(() => {
      const el = document.querySelector(selector);
      if (el) el.focus({ preventScroll: true });
    }, 120);
  }

  async function run(path, payload, el, focusSelector) {
    busy(el, true);
    try {
      showCart(await cartRequest(path, payload));
      refocus(focusSelector);
    } catch (e) {
      flashError(el, e.message);
    } finally {
      busy(el, false);
    }
  }

  /* ------------------------------------------------------------ product page */
  const mainInfo = () =>
    document.querySelector('[data-cro-bundles]')?.closest('.product__info-container') ||
    document.querySelector('.product__info-container');

  function mainForm() {
    const info = mainInfo();
    return info ? info.querySelector('product-form form[action*="/cart/add"]') : null;
  }

  function mainAddButton() {
    const form = mainForm();
    return form ? form.querySelector('[name="add"]') : null;
  }

  function mainBuyButton() {
    const info = mainInfo();
    return info ? info.querySelector('.shiprocket-headless[data-type="product"] .sr-headless-checkout') : null;
  }

  /* The ticked "Choose your gift" option, or null for "just this product". Options marked data-cro-replace are
     combo products that go in the cart instead of this product; others are extras added next to it. */
  function bundlePick(scope) {
    const box = (scope || document).querySelector('[data-cro-bundles]');
    const picked = box && box.querySelector('input[type="radio"]:checked');
    if (!picked || !picked.value) return null;
    return { id: Number(picked.value), replace: picked.hasAttribute('data-cro-replace') };
  }

  function formQty(form) {
    const input = form && form.querySelector('[name="quantity"]');
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  }

  function syncBundle(box) {
    box.querySelectorAll('.cro-bundle').forEach((label) => {
      const input = label.querySelector('input');
      label.classList.toggle('is-selected', !!(input && input.checked));
    });
    syncSticky(box);
  }

  /* The sticky bar shows the price of what Buy now will check out: the picked combo, or this product. */
  function syncSticky(box) {
    const price = document.querySelector('[data-cro-sticky-price]');
    const compare = document.querySelector('[data-cro-sticky-compare]');
    if (!price) return;
    const input = box && box.querySelector('input[type="radio"]:checked');
    const label = input && input.value && input.hasAttribute('data-cro-replace') ? input.closest('.cro-bundle') : null;
    let now = '';
    let was = '';
    if (label) {
      const b = label.querySelector('.cro-bundle__price b');
      const s = label.querySelector('.cro-bundle__price s');
      const hidden = s && s.querySelector('.visually-hidden');
      now = b ? b.textContent.trim() : '';
      was = s ? s.textContent.replace(hidden ? hidden.textContent : '', '').trim() : '';
    } else {
      const info = mainInfo();
      const ref = info && info.querySelector('[data-cro-swap="price"]');
      if (!ref) return;
      now = ref.dataset.croPrice || '';
      was = ref.dataset.croCompare || '';
    }
    if (now) price.textContent = now;
    if (compare) {
      compare.textContent = was;
      compare.hidden = !was;
    }
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cro-bundles] input[type="radio"]');
    if (input) syncBundle(input.closest('[data-cro-bundles]'));
  });

  /* Add to cart with a combo picked: put the combo product in the cart instead and open the drawer.
     With an extra item picked: add it first, then let the theme add this product and open the drawer. */
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.croPass === '1') return;
      const info = form.closest('.product__info-container');
      if (!info || !form.matches('product-form form')) return;
      const pick = bundlePick(info);
      if (!pick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const btn = form.querySelector('[name="add"]');
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      if (pick.replace) {
        run('cart/add.js', { items: [{ id: pick.id, quantity: formQty(form) }] }, btn);
        return;
      }
      const extra = pick.id;
      busy(btn, true);
      try {
        await cartRequest('cart/add.js', { items: [{ id: extra, quantity: 1 }] }, false);
        busy(btn, false);
        form.dataset.croPass = '1';
        if (typeof form.requestSubmit === 'function') form.requestSubmit(btn || undefined);
        else if (btn) btn.click();
      } catch (e) {
        if (btn) flashError(btn, e.message);
      } finally {
        delete form.dataset.croPass;
        busy(btn, false);
      }
    },
    true
  );

  /* Buy now with a combo (or extra) picked: put it in the cart, then go straight to checkout,
     or show the cart if it already had other items. */
  async function buyBundle(btn, pick) {
    const form = btn.closest('form') || mainForm();
    const idInput = form && form.querySelector('[name="id"]');
    const id = idInput ? Number(idInput.value) : 0;
    const qty = formQty(form);
    const items = pick.replace
      ? [{ id: pick.id, quantity: qty }]
      : [
          { id, quantity: qty },
          { id: pick.id, quantity: 1 },
        ];
    if (!pick.replace && !id) return;
    busy(btn, true);
    try {
      const before = await cartCount();
      const data = await cartRequest('cart/add.js', { items });
      const sr = window.shiprocketCheckoutEvents;
      if (before === 0 && sr && typeof sr.buyCart === 'function') {
        sr.buyCart({ stopPropagation() {}, preventDefault() {}, currentTarget: btn, target: btn });
      } else {
        showCart(data);
      }
    } catch (e) {
      flashError(btn, e.message);
    } finally {
      busy(btn, false);
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const sr = event.target.closest('.shiprocket-headless[data-type="product"] .sr-headless-checkout');
      if (!sr) return;
      const info = sr.closest('.product__info-container');
      const pick = info && bundlePick(info);
      if (!pick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (sr.getAttribute('aria-busy') === 'true') return;
      buyBundle(sr, pick);
    },
    true
  );

  /* ------------------------------------------------------------ frequently bought together */
  const rupees = (paise) => '₹' + Math.round(paise / 100).toLocaleString('en-IN');

  function fbtUpdate(box) {
    const all = [...box.querySelectorAll('input[type="checkbox"]')];
    const on = all.filter((b) => b.checked);
    const total = on.reduce((sum, b) => sum + (parseInt(b.dataset.price, 10) || 0), 0);
    const out = box.querySelector('[data-cro-fbt-total]');
    if (out) out.textContent = rupees(total);
    const btn = box.querySelector('[data-cro-fbt-add]');
    if (!btn) return;
    btn.disabled = on.length === 0;
    if (on.length === 2 && all.length === 2) btn.textContent = 'Add both to cart';
    else if (on.length > 1 && on.length === all.length) btn.textContent = 'Add all ' + on.length + ' to cart';
    else if (on.length > 1) btn.textContent = 'Add ' + on.length + ' to cart';
    else btn.textContent = 'Add to cart';
  }

  document.addEventListener('change', (event) => {
    const box = event.target.closest('[data-cro-fbt]');
    if (box && event.target.type === 'checkbox') fbtUpdate(box);
  });

  async function fbtAdd(btn) {
    const box = btn.closest('[data-cro-fbt]');
    const extras = [...box.querySelectorAll('[data-cro-fbt-item]:checked')].map((i) => ({ id: Number(i.value), quantity: 1 }));
    const main = box.querySelector('[data-cro-fbt-main]');
    const form = mainForm();
    const add = mainAddButton();
    if (main && main.checked && form && add && !add.disabled && add.getAttribute('aria-disabled') !== 'true') {
      busy(btn, true);
      try {
        if (extras.length) await cartRequest('cart/add.js', { items: extras }, false);
        /* This product goes in through the theme's own form, which also opens the cart. */
        form.dataset.croPass = '1';
        if (typeof form.requestSubmit === 'function') form.requestSubmit(add);
        else add.click();
      } catch (e) {
        flashError(btn, e.message);
      } finally {
        delete form.dataset.croPass;
        busy(btn, false);
      }
      return;
    }
    if (extras.length) run('cart/add.js', { items: extras }, btn);
  }

  /* ------------------------------------------------------------ clicks */
  document.addEventListener('click', (event) => {
    const gift = event.target.closest('[data-cro-giftwrap]');
    if (gift) {
      event.preventDefault();
      if (gift.getAttribute('aria-busy') === 'true') return;
      if (gift.getAttribute('aria-checked') === 'true') {
        const line = gift.dataset.lineKey || Number(gift.dataset.variantId);
        run('cart/change.js', { id: line, quantity: 0 }, gift, '[data-cro-giftwrap]');
      } else {
        run('cart/add.js', { items: [{ id: Number(gift.dataset.variantId), quantity: 1 }] }, gift, '[data-cro-giftwrap]');
      }
      return;
    }

    const fbt = event.target.closest('[data-cro-fbt-add]');
    if (fbt) {
      event.preventDefault();
      if (fbt.getAttribute('aria-busy') !== 'true') fbtAdd(fbt);
      return;
    }

    const add = event.target.closest('[data-cro-add]');
    if (add) {
      event.preventDefault();
      if (add.getAttribute('aria-busy') === 'true') return;
      const items = add.dataset.croAdd
        .split(',')
        .filter(Boolean)
        .map((id) => ({ id: Number(id), quantity: 1 }));
      run('cart/add.js', { items }, add);
      return;
    }

    const sticky = event.target.closest('[data-cro-sticky-add]');
    if (sticky) {
      event.preventDefault();
      const buy = sticky.dataset.mode !== 'add' ? mainBuyButton() : null;
      const btn = buy || mainAddButton();
      if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') {
        btn.click();
      } else {
        const info = mainInfo();
        if (info) info.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  function initSticky() {
    const bar = document.querySelector('[data-cro-sticky]');
    const btn = mainAddButton();
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    document.body.classList.add('cro-has-sticky');
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
    });
    io.observe(btn);
  }

  /* ------------------------------------------------------------ variant change */
  function onVariantChange(event) {
    const html = event && event.data && event.data.html;
    if (!html || typeof html.querySelectorAll !== 'function') return;
    const info = mainInfo();
    if (!info) return;
    html.querySelectorAll('[data-cro-swap]').forEach((src) => {
      const key = src.dataset.croSwap;
      const dst = info.querySelector('[data-cro-swap="' + key + '"]');
      if (!dst) return;
      const checked = key === 'bundles' ? dst.querySelector('input:checked') : null;
      const kind = checked ? checked.dataset.croBundleKind : null;
      dst.innerHTML = src.innerHTML;
      ['croPrice', 'croCompare'].forEach((k) => {
        if (src.dataset[k] !== undefined) dst.dataset[k] = src.dataset[k];
      });
      if (kind) {
        const again = dst.querySelector('input[data-cro-bundle-kind="' + kind + '"]');
        if (again) {
          again.checked = true;
          syncBundle(dst);
        }
      }
    });
    const ref = info.querySelector('[data-cro-swap="price"]');
    const price = document.querySelector('[data-cro-sticky-price]');
    const compare = document.querySelector('[data-cro-sticky-compare]');
    if (ref && price && ref.dataset.croPrice) price.textContent = ref.dataset.croPrice;
    if (ref && compare) {
      compare.textContent = ref.dataset.croCompare || '';
      compare.hidden = !ref.dataset.croCompare;
    }
    const box = info.querySelector('[data-cro-bundles]');
    if (box) syncSticky(box);
  }

  /* ------------------------------------------------------------ reviews widget (Judge.me) */
  function tuneReviews() {
    const w = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
    if (!w) return false;
    if (w.dataset.cro === '1') return true;
    if (!w.querySelector('.jdgm-rev')) return false;
    w.dataset.cro = '1';
    const title = w.querySelector('.jdgm-rev-widg__title');
    if (title && title.textContent.trim() === 'Customer Reviews') title.textContent = 'Customer reviews';
    const avg = parseFloat(w.dataset.averageRating);
    const n = parseInt(w.dataset.numberOfReviews, 10) || 0;
    const inner = w.querySelector('.jdgm-rev-widg__summary-inner');
    if (inner && !Number.isNaN(avg)) {
      const big = document.createElement('span');
      big.className = 'cro-jdgm-avg';
      big.setAttribute('aria-hidden', 'true');
      big.textContent = avg.toFixed(1);
      inner.prepend(big);
      const count = document.createElement('span');
      count.className = 'cro-jdgm-count';
      count.textContent = n + (n === 1 ? ' review' : ' reviews');
      inner.append(count);
    }
    const body = w.querySelector('.jdgm-rev-widg__body');
    if (n > 3 && body) {
      w.classList.add('cro-jdgm-collapsed');
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'cro-jdgm-more';
      more.textContent = 'See all ' + n + ' reviews';
      more.addEventListener('click', () => {
        w.classList.remove('cro-jdgm-collapsed');
        more.remove();
      });
      body.after(more);
    }
    return true;
  }

  function watchReviews() {
    const host = document.getElementById('judgeme_product_reviews');
    if (!host || tuneReviews()) return;
    /* Judge.me fills the widget late (when it scrolls into view), so wait for its reviews to appear. */
    if (!('MutationObserver' in window)) return;
    const mo = new MutationObserver(() => {
      if (tuneReviews()) mo.disconnect();
    });
    mo.observe(host, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------ init */
  function init() {
    fillEta();
    initSticky();
    watchReviews();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
    const d = drawer();
    if (d && 'MutationObserver' in window) {
      let t;
      new MutationObserver(() => {
        clearTimeout(t);
        t = setTimeout(() => fillEta(d), 30);
      }).observe(d, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
